// extracted by mini-css-extract-plugin
export default {"messageOwn":"Message_messageOwn__TkJhP","messageOther":"Message_messageOther__fEv+P","chatText":"Message_chatText__Hdl1Z","chatTime":"Message_chatTime__OUP74"};